import { render, staticRenderFns } from "./CategoriesOfRequestedDocuments.vue?vue&type=template&id=da4bcf54&"
import script from "./CategoriesOfRequestedDocuments.vue?vue&type=script&lang=js&"
export * from "./CategoriesOfRequestedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports